import { biToast } from '@pulsepointinc/bi-components';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '../../lib';
import {
  type CreateScheduleRequest,
  type CreateScheduleResponse,
  createSchedule,
  type DeleteScheduleRequest,
  type DeleteScheduleResponse,
  deleteSchedule,
  type UpdateScheduleRequest,
  type UpdateScheduleResponse,
  updateSchedule,
} from '../../lib/api/schedule';
import { API_TAGS } from '../../lib/constants';

export function useCreateNewScheduleMutation() {
  const mutation = useMutation<CreateScheduleResponse, unknown, CreateScheduleRequest>({
    mutationFn: createSchedule,
    mutationKey: ['createNewSchedule'],
    onError: () => {
      biToast.error('NPI list export schedule error. Try again.');
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [API_TAGS.Schedules],
      });
    },
  });

  return {
    ...mutation,
    trigger: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isFetching: mutation.isPending,
  };
}

export function useUpdateScheduleMutation() {
  const mutation = useMutation<UpdateScheduleResponse, unknown, UpdateScheduleRequest>({
    mutationFn: updateSchedule,
    mutationKey: ['updateSchedule'],
    onError: () => {
      biToast.error('NPI list export schedule error. Try again.');
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [API_TAGS.Schedules],
      });
    },
  });

  return {
    ...mutation,
    trigger: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isFetching: mutation.isPending,
  };
}
export function useDeleteScheduleMutation() {
  const mutation = useMutation<DeleteScheduleResponse, unknown, DeleteScheduleRequest>({
    mutationFn: deleteSchedule,
    mutationKey: ['deleteSchedule'],
    onError: () => {
      biToast.error('NPI list export schedule error. Try again.');
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [API_TAGS.Schedules],
      });
    },
  });

  return {
    ...mutation,
    trigger: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isFetching: mutation.isPending,
  };
}
